import {defaultPagination} from "@/services/pagination";
import {
  cancelCompare,
  deleteCompare,
  downloadCompare,
  listCompare,
  listComparison
} from "@/services/api/app/office/recovery/entraId/compare";

const defaultState = () => ({
  compares: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'initiatedAt'
  },

  comparison: [],
  paginationComparison: {
    ...defaultPagination(),
    sortBy: 'displayName',
    sortDescending: false
  },
  comparisonDetails: [],
});

export default {
  namespaced: true,
  actions: {
    listCompare({commit, state}) {
      return listCompare({
        pagination: state.pagination,
        sourceType: 'USER',
        dataTypes: ['DRIVE'],
      })
        .then(({result, pagination}) => {
          commit('setCompares', result)
          commit('setPagination', pagination)
        })
    },
    deleteCompare({commit, state}, {id}) {
      return deleteCompare(id)
    },
    downloadCompare({commit, state}, {id}) {
      return downloadCompare(id)
    },
    cancelCompare({commit, state}, {id}) {
      return cancelCompare(id, 'entra-id')
    },
    listComparison({commit, state}, data) {
      return listComparison({
        ...data,
        pagination: state.paginationComparison,
        id: data.id,
        searchTerm: data.searchTerm,
        sortDescending: false
      })
        .then(({result, pagination}) => {
          commit('setComparison', result?.result)
          commit('setPaginationComparison', pagination)
          commit('setComparisonDetails', result)
        })
    },
  },

  mutations: {
    setCompares(state, compares) {
      state.compares = compares;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'initiatedAt',
      };
    },
    setComparison(state, comparison) {
      state.comparison = comparison;
    },
    setPaginationComparison(state, paginationComparison) {
      state.paginationComparison = paginationComparison;
    },
    setComparisonDetails(state, comparison) {
      state.comparisonDetails = comparison;
    },
    resetPaginationComparison(state) {
      state.paginationComparison = {
        ...defaultPagination(),
        sortBy: 'displayName',
        sortDescending: false
      };
    },

    resetState(state) {
      Object.assign(state, defaultState())
    }
  },

  getters: {
    comparisonRows(state) {
      const comparisonEntries = state.comparison;
      const rows = [];
      comparisonEntries.forEach(entry => {
        const items = entry?.data || [];
        items.forEach(item => {
          const firstSnapshot = item.firstSnapshot || null;
          const secondSnapshot = item.secondSnapshot || null;

          const entraObjectEntry = (firstSnapshot?.entraObject) || (secondSnapshot?.entraObject) || {};

          // fetching the entries statuses
          const removed = firstSnapshot && !secondSnapshot;
          const added = !firstSnapshot && secondSnapshot;
          const changed = item.changedRecords || 0;
          const unchanged = firstSnapshot && secondSnapshot && changed === 0;

          // Check for which value is pre-selected in the dataFrom dropdown
          let defaultSnapshot;
          if (removed) {
            defaultSnapshot = 'first';
          } else if (added) {
            defaultSnapshot = 'second';
          } else if (firstSnapshot && secondSnapshot && changed > 0) {
            defaultSnapshot = 'second';
          } else if (unchanged) {
            defaultSnapshot = 'first';
          }

          rows.push({
            objectLabel: entraObjectEntry.displayName || null,
            firstSnapshotDateTime: (firstSnapshot?.entraObject?.firstSnapshot) || (secondSnapshot?.entraObject?.firstSnapshot) || null,
            objectId: entraObjectEntry.objectId || entraObjectEntry.id || null,
            objectStatus: (secondSnapshot?.objectStatus ?? firstSnapshot?.objectStatus) ?? null,
            firstSnapshot: firstSnapshot,
            secondSnapshot: secondSnapshot,
            removedRecords: item.removedRecords,
            changedRecords: item.changedRecords,
            addedRecords: item.addedRecords,
            defaultSnapshot,
          });
        });
      });

      return rows;
    },
  },

  state: defaultState(),
}
